import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { GlobalContext } from "../../Context/GlobalContext";

const useAdminLogin = () => {
  const { baseUrl, basicAuth } = useContext(GlobalContext);

  const config = {
    headers: {
      Authorization: basicAuth,
      "Content-Type": "application/json",
    },
  };

  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");

  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  const [step, setStep] = useState(1);
  const [isOTPVisible, setIsOTPVisible] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLatitude(position.coords.latitude);
        setLongitude(position.coords.longitude);
      },
      (error) => {
        console.warn("Location error:", error.message);
      }
    );
  }, []);

  const sendOtp = async () => {
    try {
      setLoading(true);

      const payload = {
        mobile: mobileNumber,
        password,
        step: "1",
        otp: "",
        latitude,
        longitude,
      };

      const response = await axios.post(
        `${baseUrl}/Admin/login`,
        payload,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setStep(2);
        setIsOTPVisible(true);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error sending OTP");
      console.error("OTP Send Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async () => {
    try {
      setLoading(true);

      const payload = {
        mobile: mobileNumber,
        password,
        step: "2",
        otp,
        latitude,
        longitude,
      };

      const response = await axios.post(
        `${baseUrl}/Admin/login`,
        payload,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);

        sessionStorage.setItem(
          "AdminUser",
          JSON.stringify(response.data.response)
        );

        window.location.href = "/admin/dashboard";

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error verifying OTP");
      console.error("OTP Verify Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const loginHandler = async () => {
    if (step === 1) {
      await sendOtp();
      return;
    }

    if (step === 2) {
      await verifyOtp();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!mobileNumber || !password) {
      toast.error("Please fill in all fields");
      return;
    }

    loginHandler();
  };

  const handleOTPSubmit = (e) => {
    e.preventDefault();

    if (!otp || otp.length < 6) {
      toast.error("OTP must be at least 6 digits");
      return;
    }

    loginHandler();
  };

  const goBackToLogin = () => {
    setIsOTPVisible(false);
    setStep(1);
    setOtp("");
  };

  return {
    mobileNumber,
    setMobileNumber,

    password,
    setPassword,

    otp,
    setOtp,

    latitude,
    longitude,

    step,
    setStep,

    isOTPVisible,
    setIsOTPVisible,

    loading,

    handleSubmit,
    handleOTPSubmit,
    goBackToLogin,
    sendOtp,
    verifyOtp,
  };
};

export default useAdminLogin;